import 'dayjs/locale/ru';

import { FC, ReactNode } from 'react';

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';

dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.locale('ru');

type DayjsProviderProps = {
  children: ReactNode;
};

export const DayjsProvider: FC<DayjsProviderProps> = ({ children }) => {
  return <>{children}</>;
};
